import { createAsyncThunk } from "@reduxjs/toolkit";
// import { DealsNetworkService } from "../../Slices/Deals/deals.NetworkService";
import { DealsNetworkService } from "../../Slices/Deals/dealsNetworkService";
import _ from "lodash";

export class dealsActions {
    // Create Pipeline
    static createPipeline = createAsyncThunk(
        "DealsSlice/CreatePipeline",
        (pipelineData: { name: string; stages: any[] },
            { dispatch, rejectWithValue }) => {
            return DealsNetworkService.createPipeline(pipelineData)
                .then(async (response: any) => {
                    return response;
                })
                .catch((error: { response: unknown }) => {
                    return rejectWithValue(error?.response);
                })
                .finally(() => { });
        },

    );

    // Get All Pipelines
    static getAllPipelines = createAsyncThunk(
        "DealsSlice/GetAllPipelines",
        async (_, { rejectWithValue }) => {
            try {
                const response = await DealsNetworkService.getAllPipelines();
                return response.data;
            } catch (error: any) {
                return rejectWithValue(error?.response);
            }
        },
    );

    //Update deal by id............
    static updateDealById = createAsyncThunk(
        "DealsSlice/updateDealById",
        async ({ dealId, dealData }: { dealId: string, dealData: any }, { rejectWithValue }) => {
            return DealsNetworkService.updateDealById(dealId, dealData)
                .then((response: any) => {
                    return response;
                })
                .catch((error: {
                    message: any; response: any
                }) => {
                    return rejectWithValue(
                        error?.response?.data?.error || error.message || "Failed to update the deal"
                    );
                })
        }
    )


    // Update Pipeline
    static updatePipeline = createAsyncThunk(
        "DealsSlice/updatePipeline",
        (
            { pipelineId, pipelineData }: { pipelineId: string; pipelineData: { name: string; stages: any[] } },
            { dispatch, rejectWithValue }
        ) => {
            return DealsNetworkService.updatePipeline(pipelineId, pipelineData)
                .then((response: any) => {
                    return response;
                })
                .catch((error: {
                    message: any; response: any
                }) => {
                    // Handle API error response
                    return rejectWithValue(
                        error?.response?.data?.error || error.message || "Failed to update pipeline"
                    );
                });
        }
    );

    //get deal by id..........
    static getDealById = createAsyncThunk("DealsSlice/getDealById",
        async ({ dealId }: { dealId: string }, { rejectWithValue }) => {
            return DealsNetworkService.getDealById(dealId)
                .then((response: any) => {
                    return response;
                })
                .catch((error: {
                    message: any; response: any
                }) => {
                    return rejectWithValue(
                        error?.response?.data?.error || error.message || "Failed to fetch the deal"
                    );
                })
        }
    )

    //delete pipeline
    static deletePipeline = createAsyncThunk(
        "DealsSlice/deletePipeline",
        async (
            { pipelineId }: { pipelineId: string },
            { rejectWithValue }
        ) => {
            return DealsNetworkService.deletePipeline(pipelineId)
                .then((response: any) => {
                    return response;
                })
                .catch((error: {
                    message: any; response: any
                }) => {
                    // Handle API error response
                    return rejectWithValue(
                        error?.response?.data?.error || error.message || "Failed to delete pipeline"
                    );
                });
        }
    );

    //create a lost reason and update existing one
    static createLostReason = createAsyncThunk(
        "DealsSlice/CreateLostReason",
        (lostReasonData: { lost_reasons: any[] },
            { dispatch, rejectWithValue }) => {
            return DealsNetworkService.createLostReason(lostReasonData)
                .then(async (response: any) => {

                    return response;
                })
                .catch((error: { response: unknown }) => {
                    return rejectWithValue(error?.response);
                })
                .finally(() => { });
        },

    );


    static getDealForm = createAsyncThunk(
        "DealsSlice/getDealForm",
        (data: any, { dispatch, rejectWithValue }) => {
            return DealsNetworkService.getDealForm()
                .then(async (response: any) => {

                    return response.data;
                })
                .catch((error: { response: unknown }) => {
                    return rejectWithValue(error?.response);
                })
                .finally(() => { });
        },
    );

    //delete stage
    static deleteStage = createAsyncThunk(
        "DealsSlice/deleteStage",
        async (
            { pipelineId, stageId }: { pipelineId: string, stageId: string },
            { rejectWithValue }
        ) => {
            return DealsNetworkService.deleteStage(pipelineId, stageId)
                .then((response: any) => {
                    return response.data;
                })
                .catch((error: {
                    message: any; response: any
                }) => {
                    // Handle API error response
                    return rejectWithValue(
                        error?.response?.data?.error || error.message || "Failed to delete pipeline's stage"
                    );
                });
        }
    );


    //get lost reasons
    static getLostReasons = createAsyncThunk(
        "DealsSlice/GetLostReasons",
        async (_, { rejectWithValue }) => {
            try {
                const response = await DealsNetworkService.getLostReasons();
                return response.data;
            } catch (error: any) {
                return rejectWithValue(error?.response);
            }
        },
    );

    static setLostReasons = createAsyncThunk(
        "DealsSlice/setLostReasons",
        (data: any, { dispatch, rejectWithValue }) => {
            return DealsNetworkService.setLostReasons(data)
                .then(async (response: any) => {

                    return response.data;
                })
                .catch((error: { response: unknown }) => {
                    return rejectWithValue(error?.response);
                })
                .finally(() => { });
        },
    );

    static deleteLostReason = createAsyncThunk(
        "DealsSlice/deleteLostReason",
        (data: any, { dispatch, rejectWithValue }) => {
            return DealsNetworkService.DeleteLostReasons(data)
                .then(async (response: any) => {

                    return response.data;
                })
                .catch((error: { response: unknown }) => {
                    return rejectWithValue(error?.response);
                })
                .finally(() => { });
        },
    );
    //get all deals 
    static getDealList = createAsyncThunk(
        "DealsSlice/GetDealList",
        async ({ columns, pipeline, deal_status, owner, search, limit, offset, contact_id }: { columns: string[], offset: number, pipeline: string, deal_status: string, owner: string, search: string, limit: number, contact_id: string }, { rejectWithValue }) => {

            try {
                const response = await DealsNetworkService.getDealList(columns, pipeline, deal_status, owner, search, offset, limit, contact_id);

                return response.data;

            } catch (error: any) {
                return rejectWithValue(error?.response);
            }
        },
    );

    static createDeal = createAsyncThunk(
        "DealsSlice/CreateDeal",
        (dealData: any, { dispatch, rejectWithValue }) => {
            return DealsNetworkService.createDeal(dealData)
                .then(async (response: any) => {

                    return response.data;
                })
                .catch((error: { response: unknown }) => {
                    return rejectWithValue(error?.response);
                })
                .finally(() => { });
        },

    );

    //CREATE DEAL NOTE........
    static createDealNote = createAsyncThunk(
        "DealsSlice/CreateDealNote",
        (dealNoteData: any, { dispatch, rejectWithValue }) => {
            return DealsNetworkService.createDealNote(dealNoteData)
                .then(async (response: any) => {
                    return response.data;
                })
                .catch((error: { response: unknown }) => {
                    return rejectWithValue(error?.response);
                });
        }
    );

    static deleteDeal = createAsyncThunk(
        "DealsSlice/deleteDeal",
        async (
            { dealId }: { dealId: string },
            { rejectWithValue }
        ) => {
            return DealsNetworkService.deleteDeal(dealId)
                .then((response: any) => {
                    console.log("Response for deleting deal", response);
                    return response;
                })
                .catch((error: {
                    message: any; response: any
                }) => {
                    // Handle API error response
                    return rejectWithValue(
                        error?.response?.data?.error || error.message || "Failed to delete deal"
                    );
                });
        }
    );

    //get-deal-form-fields

    // static getDealFormFields = createAsyncThunk(
    //     "DealsSlice/GetAllPipelines",
    //     async (_, { rejectWithValue }) => {
    //         try {
    //             const response = await DealsNetworkService.getDealFormFields();
    //             return response.data;
    //         } catch (error: any) {
    //             return rejectWithValue(error?.response);
    //         }
    //     },
    // );


}




